
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pipe]/2-test",
      function () {
        return require("private-next-pages/[pipe]/2-test.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pipe]/2-test"])
      });
    }
  